import type { CVEditingSection, FullCV } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface LanguagesProps {
  languages: FullCV['languages'];
  accent: string;
  onEdit?: (section: CVEditingSection) => void;
}

export default function Languages({ languages, accent, onEdit }: LanguagesProps) {
  const { t } = useCVTranslation();
  const handleEdit = () => onEdit && onEdit('languages');
  const editable = onEdit !== undefined;

  if (!languages?.length && !editable) return null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable} accentColor={accent}>
      <div className="rounded-lg border p-2.5">
        <h2 className="text-[11px] font-black uppercase tracking-widest text-black">
          {t('CV.languages')}
        </h2>
        <ul className="mt-1 space-y-1">
          {(languages ?? []).map((l, i) => (
            <li key={i} className="text-[11px] font-semibold">
              • {l.language} ({l.level})
            </li>
          ))}
        </ul>
      </div>
    </EditableSection>
  );
}
